import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_BANKDETAILS, ADD_BANKDETAILS_FAILED, ADD_BANKDETAILS_SUCCESS, BANKDETAILS, BANKDETAILS_FAILED, BANKDETAILS_SUCCESS, UPDATE_BANKDETAILS, UPDATE_BANKDETAILS_FAILED, UPDATE_BANKDETAILS_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"


export const getBankdetails = (id) => async (dispatch) => {
  dispatch({
    type: BANKDETAILS,
  });
  try {
    let response = await api(`bankdetails/bankdetailsList`, "get", { id }, getAuthHeader());
    dispatch({
      type: BANKDETAILS_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Bankdetails list error ====>", error);
    return dispatch({
      type: BANKDETAILS_FAILED,
      payload: error?.message,
    });
  }
};

export const getAllBankdetails = () => async (dispatch) => {
  dispatch({
    type: BANKDETAILS,
  });
  try {
    let response = await api(`bankdetails/all`, "get", {}, getAuthHeader());
    dispatch({
      type: BANKDETAILS_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching all Bankdetailss list error ====>", error);
    return dispatch({
      type: BANKDETAILS_FAILED,
      payload: error?.message,
    });
  }
};

export const addBankdetails = (data) => async dispatch => {
  dispatch({
    type: ADD_BANKDETAILS
  })
  try {
    let response = await api(`bankdetails/add`, 'post', data, getAuthHeader())
    console.log('add bankdetails data', response);
    toast.success("Bankdetails Saved Successfully");
    dispatch({
      type: ADD_BANKDETAILS_SUCCESS,
      payload: response?.data
    })
    await dispatch(getBankdetails())
    return response
  } catch (error) {
    console.log("while Adding bankdetails error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_BANKDETAILS_FAILED,
      payload: error?.message
    })
  }
}

export const updateBankdetails = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_BANKDETAILS
  })
  try {
    let response = await api(`bankdetails/update/${id}`, 'put', data, getAuthHeader())
    console.log('update bankdetails data', response);
    toast.success("Bankdetails Updated Successfully");
    dispatch({
      type: UPDATE_BANKDETAILS_SUCCESS,
      payload: response?.data
    })
    await dispatch(getBankdetails())
    return response
  } catch (error) {
    console.log("while updating bankdetails error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_BANKDETAILS_FAILED,
      payload: error?.message
    })
  }
}